import { ForwardToFolderAction } from '@/forwarding/types/ForwardDestinationListData';
export function getModalTitle(action) {
    switch (action) {
        case ForwardToFolderAction.Add:
            return 'Add to Folder';
        case ForwardToFolderAction.Move:
            return 'Move to Folder';
    }
}
